import React, { useState } from 'react';
import { connect } from 'react-redux';
import Loading from '../../../../../components/Loading/Loading';
import SectionCards from '../../../../../components/MedicalAttention/MedicalProviderDirectory/SectionCards';
import MedicalProviderDirectoryService from '../../../../../services/medicalProviderDirectory';
import { openModalError } from '../../../../../utils/modals';
import SpecialtiesFilter from '../../../../../components/MedicalAttention/MedicalProviderDirectory/Filter/Specialities';
import RenderProvider from '../../../../../components/MedicalAttention/Providers/RenderProvider';
import {
  medicalProviderDirectorySpecialtiesLabels,
  medicalProviderDirectorySpecialtiesTypes,
} from '../../../../../constants/medicalAttention';

const SpecialtySearch = ({ affiliateData, section }) => {
  const [list, setList] = useState(null);
  const [loading, setLoading] = useState(false);

  const onFilter = async ({ speciality, address }) => {
    setLoading(true);
    try {
      const cartillaId = affiliateData?.plan?.cartilla?.id ?? '';
      const data = await MedicalProviderDirectoryService.getPracticionersBySpecialityAndType(
        cartillaId,
        speciality,
        address,
        medicalProviderDirectorySpecialtiesTypes[section],
      );
      setList(data);
    } catch (error) {
      const errorTitle = medicalProviderDirectorySpecialtiesLabels[section];
      openModalError({ title: errorTitle });
    } finally {
      setLoading(false);
    }
  };

  return (
    <RenderProvider>
      {loading && <Loading />}
      <SpecialtiesFilter onFilter={onFilter} affiliateData={affiliateData} section={section} />
      <SectionCards list={list} affiliateData={affiliateData} />
    </RenderProvider>
  );
};

const mapStateToProps = (state) => ({
  affiliateData: state.affiliate?.data,
});

export default connect(mapStateToProps)(SpecialtySearch);
